import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import type * as React from "react";

import { cn } from "@/web/lib/styling";

function Checkbox({
  className,
  indicatorClassName,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  indicatorClassName?: string;
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="withus-checkbox"
      className={cn(
        "peer size-4 shrink-0 cursor-pointer rounded-none border border-current bg-transparent text-current outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-current",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="withus-checkbox-indicator"
        className="flex items-center justify-center"
      >
        <div className={cn("size-2", indicatorClassName)} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
export { Checkbox };
